export function supportsLanguage(lang) {
  return ['svSE', 'nbNO', 'fiFI'].includes(lang);
}
